import { PurchasingRepository } from '@Purchasing/Data/Repository/PurchasingRepository'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'

export interface GetPurchaseProcessById {
    execute(id: string): Promise<PurchaseProcess>
    getSource(): string
}

export class GetPurchaseProcessByIdUseCase implements GetPurchaseProcessById {
    constructor(private repository: PurchasingRepository) {}
    async execute(id: string): Promise<PurchaseProcess> {
        return this.repository.findById(id)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
